module.exports = __webpack_public_path__ + "static/media/3@3x.7dec8ac1.png";